import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    ICompanySetMeetingDateClient,
} from 'interfaceAdapter/gatewaySchemas/ICompanySetMeetingDateClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/company/set_meeting_date`;

export class CompanySetMeetingDateClient implements ICompanySetMeetingDateClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, match_id, meeting_date } = input;
        const method = 'POST';

        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-C': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({ match_id: match_id, meeting_date: meeting_date });

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
